import { useEffect, useRef, useState } from "react";

const GoogleAddressSearch = ({ onSelect, defaultValue }) => {
  const inputRef = useRef(null);
  const [isGoogleAddressSelected, setIsGoogleAddressSelected] = useState(false);

  useEffect(() => {
    if (!window.google || !window.google.maps || !inputRef.current) return;

    // Empêche l'autocomplete navigateur (Chrome, Android...)
    inputRef.current.setAttribute("autocomplete", "new-password");

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ["address"],
      componentRestrictions: { country: "fr" },
      fields: ["address_components", "formatted_address"],
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      setIsGoogleAddressSelected(true);
      onSelect(place);
    });
  }, [onSelect]);

  // Lorsque l’utilisateur tape → il filtre la liste Google, mais ce n'est pas une "vraie" adresse tant qu'il n'a pas cliqué
  const handleManualInput = () => {
    setIsGoogleAddressSelected(false);
  };

  return (
    <>
      <input type="text" name="fake1" autoComplete="off-rand1" style={{ display: "none" }} />
      <input
        ref={inputRef}
        defaultValue={defaultValue || ""}
        placeholder="Rechercher une adresse"
        autoComplete="new-password"
        name="fake-address-input"
        id="fake-address-input"
        onInput={handleManualInput}
        onPaste={handleManualInput}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !isGoogleAddressSelected) {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        onBlur={(e) => {
          // On empêche de valider une adresse non Google
          if (!isGoogleAddressSelected) {
            e.target.value = "";
          }
        }}
        style={{
          padding: "10px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      />

    </>
  );
};

export default GoogleAddressSearch;
